import { render, staticRenderFns } from "./mail-list-operation.vue?vue&type=template&id=8bf58f34&scoped=true"
import script from "./mail-list-operation.vue?vue&type=script&lang=js"
export * from "./mail-list-operation.vue?vue&type=script&lang=js"
import style0 from "./mail-list-operation.vue?vue&type=style&index=0&id=8bf58f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf58f34",
  null
  
)

export default component.exports